namespace SPA
{
	export namespace Realtor2
	{
		export class NewPremiseObject extends ui.tab.TabHTMLPresentation
		{

			private m_Guide:		SPA.Guide.GuideRoot;
			private m_Data:
			{
				object: IPremiseObject;
				property: IProperty;
				general: IFinal;
			};

			private m_Order: IOrder;

			public constructor(private m_Company: Wollmilch.CompanyObject, object: any = null)
			{
				super();

				this.m_Guide		= new SPA.Guide.GuideRoot();
				this.m_Data			=
				{
					object:
					{
						project: 'premise',
						address:
						{
							street: '',
							housenumber: '',
							postalcode: '',
							city: '',
							state: '',
							country: 'DE',
							ags: '',
						},
						quality:
						{
							micro: -1,
							macro: -1,
							annotation: ''
						},
						seller:
						{
							id: null,
						},
						owner:
						{
							id: null,
						}
					},
					property:
					{
						area:
						{
							building: null,
							garden: null
						},
						leasehold:
						{
							present: false,
							residual_time: 0,
							ground_rent: 0,
							compensation: 0,
							disadvantage: 0,
							rate: 0,
							annotation: ''
						},
						structural:
						{
							path: null,
							layout:
							{
								value: null,
								corner: false,
								pipe: false,
								slope: false,
								towel: false
							},
							garden: null,
							courtyard: null,
							enclosure: null,
							annotation: ''
						},
						register:
						{
							registry_deeds: '',
							court: '',
							volume: '',
							page: '',
							list: [],
							active_annotation: '',
							annotation: ''
						},
						easements: {
							value: 'NOTHING',
							annotation: ''
						},
						preload: [],
						annotation: ''
					},
					general:
					{
						price:
						{
							value: null,
							currency: 'EUR'
						},
						yearlyRent:
						{
							value: null,
							currency: 'EUR'
						},
						fee:
						{
							interior: null,
							exterior: null
						},
						order_until:
						{
							value: null,
							format: 'd.m.Y'
						},
						title: '',
						annotation: '',
						ref: ''
					}
				};

				if (object !== null)
				{
					const newData = deepmerge(this.m_Data, object, {});
					this.m_Data = newData;
				}

				this.m_Order =
				{
					lrm: false,
					register:
					{
						order: false,
						file: null
					},
					easement:
					{
						order: false,
						file: null
					},
					datapackage: false,
					assessment:
					{
						immowertv: true,
						belwertv: true,
						belwertv_bafin: true
					}
				};

				this.buildGuide();
			}

			public setLRM( lrm: boolean ): void { this.m_Order.lrm = lrm; }
			public setDataPackage( dp: boolean ): void { this.m_Order.datapackage = dp; }
			public setRegister( register: IOrderWithFile ): void { this.m_Order.register = register; }
			public setEasement( easement: IOrderWithFile ): void { this.m_Order.easement = easement; }

			public getLRM(): boolean { return this.m_Order.lrm; }
			public getDataPackage(): boolean { return this.m_Order.datapackage; }
			public getRegister(): IOrderWithFile { return this.m_Order.register; }
			public getEasement(): IOrderWithFile { return this.m_Order.easement; }

			public sendForm(): void
			{
				new Wollmilch.AJAX(
					{
						method: 'POST',
						url: 'object/new',
						data: Object.assign(
							{
								orders: this.m_Order
							},
							this.m_Data
						),
						on:
						{
							success: ( text: string ) =>
							{
								const _json = Wollmilch.jsonize( text );

								if ( _json === null || !_json.success )
								{
									app.addNotify(
										{
											body: [
												'Das Anlegen des Objektes ist fehlgeschlagen.'
											],
											context: 'danger',
											title: [ 'Anlegen fehlgeschlagen' ],
											timeout: Number(app.getConfigValue("ToastTimeout"))
										}
									);

									return;
								}

								app.addNotify(
									{
										body: [ 'Das Objekt wurde erfolgreich angelegt.' ],
										context: 'success',
										title: [ 'Erfolg' ],
										timeout: Number(app.getConfigValue("ToastTimeout"))
									}
								);

								app.getGlobalTabControl().addTab(
									_json.data.ObjectNumber,
									new Realtor.Page( _json.data ),
									true,
									true,
									true
								);

								app.getGlobalTabControl().removeTab( this.m_Entry );

								return;
							}
						}
					},
					Wollmilch.AJAXCallbase_e.REALTOR
				).send();
			}

			public checkForm( _form: ui.Form.Form, _timeout: number = 5000 ): boolean
			{
				if ( _form.isValid( {}, [] ) )
				{
					return true;
				}

				app.addNotify(
					{
						title: [ 'Formularangaben unvollständig/inkorrekt' ],
						body: [ 'Bitte überprüfen Sie Ihre Formularangaben und korrigieren/vervollständigen Sie diese bitte.' ],
						context: 'warning',
						timeout: _timeout
					}
				);

				return false;
			}

			public rebuild( root: ui.base.BaseHTMLElement ): NewPremiseObject
			{
				this.empty();
				this.remove();

				this.appendTo( new ui.Box.Box().appendTo( root ) );

				this.m_Guide.rebuild( this );

				return this;
			}

			private buildGuide(): void
			{
				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: '1',
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Allg. Angaben'
						},
						new New.Common( this.m_Company, this.m_Data.object, this ),
						false
					)
				);

				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: '2',
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Grundstück'
						},
						new New.Property( this.m_Data.property, this ),
						false
					)
				);

				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: '3',
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Abschluss'
						},
						new New.Final( this.m_Data.general, this.m_Company, this ),
						false
					)
				);
			}

		}
	}
}
